import styled from 'styled-components';

import Content from 'ggApp/shared/components/Cart/CartOverlay';

const OverlayShadow = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 6;
    pointer-events: none;
    background: rgba(0, 0, 0, 0.5);
`;

const OverlayContainer = styled.div`
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    z-index: 6;
    overflow-y: auto;
`;

const OverlayContent = styled.div`
    position: relative;
    overflow-y: auto;
    height: 100%;
    left: 32px;
    width: calc(100% - 32px);
    ${({ theme }) => theme.superQuery.all.and.minWidth.tabletMin.css`
        left: 50%;
        width: 50%;
    `};
`;

const CartContent = styled(Content)`
    position: relative;
    height: 100%;
    background: ${({ theme }) => theme.colors.ElementBackground };
`;

export { CartContent, OverlayContainer, OverlayContent, OverlayShadow };
